module.exports = __webpack_public_path__ + "img/icon_fly_bidv.05cf092c.svg";